const TwoSheets = (props: any) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.33325 9.99998C2.712 9.99998 2.40137 9.99998 2.15634 9.89849C1.82964 9.76316 1.57007 9.50359 1.43475 9.17689C1.33325 8.93186 1.33325 8.62124 1.33325 7.99998V3.46665C1.33325 2.71991 1.33325 2.34654 1.47858 2.06133C1.60641 1.81044 1.81038 1.60647 2.06126 1.47864C2.34648 1.33331 2.71985 1.33331 3.46659 1.33331H7.99992C8.62117 1.33331 8.9318 1.33331 9.17683 1.43481C9.50353 1.57013 9.7631 1.8297 9.89843 2.1564C9.99992 2.40143 9.99992 2.71206 9.99992 3.33331M8.13325 14.6666H12.5333C13.28 14.6666 13.6534 14.6666 13.9386 14.5213C14.1895 14.3935 14.3934 14.1895 14.5213 13.9386C14.6666 13.6534 14.6666 13.28 14.6666 12.5333V8.13331C14.6666 7.38658 14.6666 7.01321 14.5213 6.72799C14.3934 6.47711 14.1895 6.27314 13.9386 6.1453C13.6534 5.99998 13.28 5.99998 12.5333 5.99998H8.13325C7.38652 5.99998 7.01315 5.99998 6.72793 6.1453C6.47705 6.27314 6.27307 6.47711 6.14524 6.72799C5.99992 7.01321 5.99992 7.38658 5.99992 8.13331V12.5333C5.99992 13.28 5.99992 13.6534 6.14524 13.9386C6.27307 14.1895 6.47705 14.3935 6.72793 14.5213C7.01315 14.6666 7.38652 14.6666 8.13325 14.6666Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default TwoSheets;
